import { getStringSchema, getSelectSchema, getBooleanSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';
import { AsOfSources } from '../../CasAsOf/AsOfSourcesSchema';

export const AsOfAdditCompensation = Yup.array().of(
  Yup.object().shape({
    employeeId: getSelectSchema('Employee'),
    insCompTypeId: getSelectSchema('Addit Compensation'),
  })
);

export const LRPAccountsSchema = Yup.object().shape({
  isSuspended: getBooleanSchema('IsSuspended', false),
  notes: getStringSchema(255, 'Notes').notRequired(),
  asOf: Yup.object().shape({
    servicingAgentId: getSelectSchema('Relationship Owner'),
    insCommScheduleId: getSelectSchema('Commission Schedule'),
    asOfAdditComps: AsOfAdditCompensation,
    asOfSources: AsOfSources,
  }),
});
